export const childrenList: { label: string; value: string }[] = [
    {
        value: '0',
        label: '0',
    },
    {
        value: '1',
        label: '1',
    },
    {
        value: '2',
        label: '2',
    },
    {
        value: '3',
        label: '3',
    },
    {
        value: '4',
        label: '4',
    },
    {
        value: '5',
        label: '5',
    },
    {
        value: '6',
        label: '6',
    },
    {
        value: '7',
        label: '7',
    },
    {
        value: '8',
        label: '8',
    },
    {
        value: '9',
        label: '9',
    },
    {
        value: '10',
        label: '10',
    },
];

export const maritalStatusList: { label: string; value: string }[] = [
    {
        label: 'Célibataire',
        value: '1',
    },
    {
        label: 'Marié',
        value: '2',
    },
    {
        label: 'Pacsé',
        value: '3',
    },
    {
        label: 'Concubinage',
        value: '4',
    },
];

export const civilityList: { label: string; value: string }[] = [
    {
        label: 'Monsieur',
        value: 'Mr',
    },
    {
        label: 'Madame',
        value: 'Mme',
    },
    {
        label: 'Mademoiselle',
        value: 'Mlle',
    },
];

const zipCodeList: string[] = ['fr', 'gp', 'mq', 'gf', 're', 'pm', 'yt', 'tf', 'wf', 'pf', 'nc', 'bl', 'mf', 'cp'];

export const searchOptions = {
    types: ['address'],
    componentRestrictions: {
        country: zipCodeList,
    },
};

export const searchOptionsPostalCode = {
    types: ['(regions)'],
    componentRestrictions: {
        country: zipCodeList,
    },
};

export const employerTypeList: { label: string; value: string }[] = [
    {
        value: '0',
        label: 'Entreprise privée',
    },
    {
        value: '1',
        label: 'Entreprise publique',
    },
    {
        value: '2',
        label: 'Entreprise du secteur agricole',
    },
];

export const contractTypeList: { label: string; value: string }[] = [
    {
        value: '0',
        label: 'CDI',
    },
    {
        value: '1',
        label: 'CDD',
    },
    {
        value: '3',
        label: 'Sans emploi',
    },
    {
        value: '4',
        label: 'Retraité',
    },
];

type TPublicOptions = {
    label: string;
    value: string;
};

type TPublicCompany = {
    label: string;
    options: TPublicOptions[];
};

export const publicCompanyList: TPublicCompany[] = [
    {
        label: 'Autres',
        options: [
            {
                value: '998',
                label: 'Autres',
            },
        ],
    },
    {
        label: 'Etablissements publics à caractère industriel et commercial (EPIC)',
        options: [
            {
                value: '0',
                label: "ADEME (Agence de l'environnement et de la maîtrise de l'énergie)",
            },
            {
                value: '1',
                label: "ADIT (Agence pour la diffusion de l'information technologique - Leader de l'intelligence stratégique)",
            },
            {
                value: '2',
                label: 'ANDRA (Agence nationale pour la gestion des déchets radioactifs)',
            },
            {
                value: '3',
                label: 'Bpifrance',
            },
            {
                value: '4',
                label: 'B.R.G.M. (Bureau de recherches géologiques et minières)',
            },
            {
                value: '5',
                label: "C.E.A. (Commissariat à l'énergie atomique)",
            },
            {
                value: '6',
                label: 'CIRAD (Centre de coopération international en recherche agronomique)',
            },
            {
                value: '7',
                label: "CNES (Centre national d'études spatiales)",
            },
            {
                value: '8',
                label: "Universcience Cité des sciences et de l'industrie",
            },
            {
                value: '9',
                label: 'C.S.T.B. (Centre scientifique et technique du bâtiment)',
            },
            {
                value: '10',
                label: 'IFPEN I.F.P. Energies nouvelles',
            },
            {
                value: '11',
                label: "IFREMER (Institut français de recherche pour l'exploitation de la mer)",
            },
            {
                value: '12',
                label: "INERIS (Institut national de l'environnement industriel et des risques)",
            },
            {
                value: '13',
                label: 'I.R.S.N. (Institut de radioprotection et de sûreté nucléaire)',
            },
            {
                value: '14',
                label: "ONERA (Office national d'études et de recherches aérospatiales)",
            },
        ],
    },
    {
        label: 'Entreprises publiques hors EPIC',
        options: [
            {
                value: '15',
                label: 'la Poste',
            },
            {
                value: '16',
                label: 'EDF',
            },
            {
                value: '17',
                label: 'Aéroports de Paris',
            },
            {
                value: '18',
                label: 'Air France',
            },
            {
                value: '19',
                label: 'Orange',
            },
            {
                value: '20',
                label: 'France Télévision',
            },
            {
                value: '21',
                label: 'DCNS',
            },
            {
                value: '22',
                label: 'GDF Suez',
            },
            {
                value: '23',
                label: 'GIAT industries-Nexter',
            },
            {
                value: '24',
                label: 'Imprimerie national',
            },
        ],
    },
    {
        label: 'Organismes privés à financement public prédominant (secteur non marchand)',
        options: [
            {
                value: '25',
                label: 'Associations',
            },
            {
                value: '26',
                label: 'Organismes de protection sociale',
            },
            {
                value: '27',
                label: 'Hôpitaux à but non lucratif',
            },
            {
                value: '28',
                label: 'SAFER (société d’aménagement foncier et d’établissement rural)',
            },
        ],
    },
];

export const isDomTom = (zipCode: string | undefined) => {
    if (!zipCode) return false;
    return +zipCode.substring(0, 2) > 95;
};

// DOM TOM

export const getDepartementNameByZipCode = (zipCode: string | undefined): string | undefined => {
    if (!zipCode || zipCode.length !== 5) return undefined;

    const department = DEPARTMENT_NAMES.find((element: DEPT) => zipCode.startsWith(element.departmentId));
    return department?.department || undefined;
};

export type DEPT = { departmentId: string; department: string };

export const DEPARTMENT_NAMES: DEPT[] = [
    {
        departmentId: '01',
        department: 'Ain',
    },
    {
        departmentId: '02',
        department: 'Aisne',
    },
    {
        departmentId: '03',
        department: 'Allier',
    },
    {
        departmentId: '04',
        department: 'Alpes de Haute-Provence',
    },
    {
        departmentId: '05',
        department: 'Hautes-Alpes',
    },
    {
        departmentId: '06',
        department: 'Alpes-Maritimes',
    },
    {
        departmentId: '07',
        department: 'Ardêche',
    },
    {
        departmentId: '08',
        department: 'Ardennes',
    },
    {
        departmentId: '09',
        department: 'Ariège',
    },
    {
        departmentId: '10',
        department: 'Aube',
    },
    {
        departmentId: '11',
        department: 'Aude',
    },
    {
        departmentId: '12',
        department: 'Aveyron',
    },
    {
        departmentId: '13',
        department: 'Bouches-du-Rhône',
    },
    {
        departmentId: '14',
        department: 'Calvados',
    },
    {
        departmentId: '15',
        department: 'Cantal',
    },
    {
        departmentId: '16',
        department: 'Charente',
    },
    {
        departmentId: '17',
        department: 'Charente-Maritime',
    },
    {
        departmentId: '18',
        department: 'Cher',
    },
    {
        departmentId: '19',
        department: 'Corrèze',
    },
    {
        departmentId: '2A',
        department: 'Corse-du-Sud',
    },
    {
        departmentId: '2B',
        department: 'Haute-Corse',
    },
    {
        departmentId: '21',
        department: "Côte-d'Or",
    },
    {
        departmentId: '22',
        department: "Côtes d'Armor",
    },
    {
        departmentId: '23',
        department: 'Creuse',
    },
    {
        departmentId: '24',
        department: 'Dordogne',
    },
    {
        departmentId: '25',
        department: 'Doubs',
    },
    {
        departmentId: '26',
        department: 'Drôme',
    },
    {
        departmentId: '27',
        department: 'Eure',
    },
    {
        departmentId: '28',
        department: 'Eure-et-Loir',
    },
    {
        departmentId: '29',
        department: 'Finistère',
    },
    {
        departmentId: '30',
        department: 'Gard',
    },
    {
        departmentId: '31',
        department: 'Haute-Garonne',
    },
    {
        departmentId: '32',
        department: 'Gers',
    },
    {
        departmentId: '33',
        department: 'Gironde',
    },
    {
        departmentId: '34',
        department: 'Hérault',
    },
    {
        departmentId: '35',
        department: 'Île-et-Vilaine',
    },
    {
        departmentId: '36',
        department: 'Indre',
    },
    {
        departmentId: '37',
        department: 'Indre-et-Loire',
    },
    {
        departmentId: '38',
        department: 'Isère',
    },
    {
        departmentId: '39',
        department: 'Jura',
    },
    {
        departmentId: '40',
        department: 'Landes',
    },
    {
        departmentId: '41',
        department: 'Loir-et-Cher',
    },
    {
        departmentId: '42',
        department: 'Loire',
    },
    {
        departmentId: '43',
        department: 'Haute-Loire',
    },
    {
        departmentId: '44',
        department: 'Loire-Atlantique',
    },
    {
        departmentId: '45',
        department: 'Loiret',
    },
    {
        departmentId: '46',
        department: 'Lot',
    },
    {
        departmentId: '47',
        department: 'Lot-et-Garonne',
    },
    {
        departmentId: '48',
        department: 'Lozère',
    },
    {
        departmentId: '49',
        department: 'Maine-et-Loire',
    },
    {
        departmentId: '50',
        department: 'Manche',
    },
    {
        departmentId: '51',
        department: 'Marne',
    },
    {
        departmentId: '52',
        department: 'Haute-Marne',
    },
    {
        departmentId: '53',
        department: 'Mayenne',
    },
    {
        departmentId: '54',
        department: 'Meurthe-et-Moselle',
    },
    {
        departmentId: '55',
        department: 'Meuse',
    },
    {
        departmentId: '56',
        department: 'Morbihan',
    },
    {
        departmentId: '57',
        department: 'Moselle',
    },
    {
        departmentId: '58',
        department: 'Nièvre',
    },
    {
        departmentId: '59',
        department: 'Nord',
    },
    {
        departmentId: '60',
        department: 'Oise',
    },
    {
        departmentId: '61',
        department: 'Orne',
    },
    {
        departmentId: '62',
        department: 'Pas-de-Calais',
    },
    {
        departmentId: '63',
        department: 'Puy-de-Dôme',
    },
    {
        departmentId: '64',
        department: 'Pyrénées-Atlantiques',
    },
    {
        departmentId: '65',
        department: 'Hautes-Pyrénées',
    },
    {
        departmentId: '66',
        department: 'Pyrénées-Orientales',
    },
    {
        departmentId: '67',
        department: 'Bas-Rhin',
    },
    {
        departmentId: '68',
        department: 'Haut-Rhin',
    },
    {
        departmentId: '69',
        department: 'Rhône',
    },
    {
        departmentId: '70',
        department: 'Haute-Saône',
    },
    {
        departmentId: '71',
        department: 'Saône-et-Loire',
    },
    {
        departmentId: '72',
        department: 'Sarthe',
    },
    {
        departmentId: '73',
        department: 'Savoie',
    },
    {
        departmentId: '74',
        department: 'Haute-Savoie',
    },
    {
        departmentId: '75',
        department: 'Paris',
    },
    {
        departmentId: '76',
        department: 'Seine-Maritime',
    },
    {
        departmentId: '77',
        department: 'Seine-et-Marne',
    },
    {
        departmentId: '78',
        department: 'Yvelines',
    },
    {
        departmentId: '79',
        department: 'Deux-Sèvres',
    },
    {
        departmentId: '80',
        department: 'Somme',
    },
    {
        departmentId: '81',
        department: 'Tarn',
    },
    {
        departmentId: '82',
        department: 'Tarn-et-Garonne',
    },
    {
        departmentId: '83',
        department: 'Var',
    },
    {
        departmentId: '84',
        department: 'Vaucluse',
    },
    {
        departmentId: '85',
        department: 'Vendée',
    },
    {
        departmentId: '86',
        department: 'Vienne',
    },
    {
        departmentId: '87',
        department: 'Haute-Vienne',
    },
    {
        departmentId: '88',
        department: 'Vosges',
    },
    {
        departmentId: '89',
        department: 'Yonne',
    },
    {
        departmentId: '90',
        department: 'Territoire-de-Belfort',
    },
    {
        departmentId: '91',
        department: 'Essonne',
    },
    {
        departmentId: '92',
        department: 'Hauts-de-Seine',
    },
    {
        departmentId: '93',
        department: 'Seine-Saint-Denis',
    },
    {
        departmentId: '94',
        department: 'Val-de-Marne',
    },
    {
        departmentId: '95',
        department: "Val-d'Oise",
    },
    {
        departmentId: '971',
        department: 'Guadeloupe',
    },
    {
        departmentId: '972',
        department: 'Martinique',
    },
    {
        departmentId: '973',
        department: 'Guyane française',
    },
    {
        departmentId: '974',
        department: 'La Réunion',
    },
    {
        departmentId: '975',
        department: 'Saint-Pierre-et-Miquelon',
    },
    {
        departmentId: '976',
        department: 'Mayotte',
    },
    {
        departmentId: '977',
        department: 'Saint-Barthélemy',
    },
    {
        departmentId: '978',
        department: 'Saint-Martin',
    },
    {
        departmentId: '984',
        department: 'Terres australes et antarctiques françaises',
    },
    {
        departmentId: '986',
        department: 'Wallis-et-Futuna',
    },
    {
        departmentId: '987',
        department: 'Polynésie française',
    },
    {
        departmentId: '988',
        department: 'Nouvelle-Calédonie',
    },
    {
        departmentId: '989',
        department: 'Clipperton',
    },
];
